import { appstr } from "@coreapp/utils/appstr";
import { ChartRuleModifier } from "./useChartRuleEditorController";

type Props = {
  entity: string;
  elements: ChartRuleModifier[];
};

export const useChartRuleController = (props: Props) => {
  const { entity, elements } = props;

  const getUniqueBlockName = () => {
    const names = new Set<string>(elements.map(entity => entity.GetName() ?? ""));
    let numbering = 1;

    while (true) {
      let potentialName = appstr("Entity i", { entity: appstr(entity), i: numbering });
      if (!names.has(potentialName)) {
        return potentialName;
      } else {
        numbering++;
      }
    }
  };

  const getDisallowedNames = (excludedName: string) => {
    const usedNames = new Set<string>();
    elements.forEach(element => {
      const elementName = element.GetName();
      if (elementName && elementName !== excludedName) {
        usedNames.add(elementName);
      }
    });

    return usedNames;
  };

  const handleNameChangeValidation = (currentName: string, name: string): any => {
    if (name === "") {
      return {
        result: false,
        msg: appstr("Entity name cannot be empty", { entity: appstr(entity) }),
        status: "danger",
        showText: true
      };
    }

    if (getDisallowedNames(currentName).has(name)) {
      return {
        result: false,
        msg: appstr(`${entity.toLowerCase()}inuse`),
        status: "danger",
        showText: true
      };
    }

    return {
      result: true,
      msg: "",
      status: "success",
      showText: false
    };
  };

  return {
    getUniqueBlockName,
    getDisallowedNames,
    handleNameChangeValidation
  };
};
